if (!customElements.get('speakon-home-purchase')) {
  customElements.define('speakon-home-purchase', class extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector('[data-purchase-quick-view]');
      if (!link) return;
      // Only reuse a modal that contains this product. The normal href remains the fallback.
      const modal = document.getElementById(link.dataset.purchaseQuickView);
      const matches = [...(modal?.querySelectorAll('option') || [])].some(option => option.value === link.dataset.purchaseVariant);
      if (!matches) return;
      link.dataset.bsToggle = 'modal';
      link.dataset.bsTarget = `#${modal.id}`;
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', modal.id);
    }
  });
}
